import LegalPageLayout from "@/components/LegalPageLayout";
import { COMPANY } from "@shared/company-info";

export default function Termos() {
  return (
    <LegalPageLayout
      title="Termos de Uso"
      subtitle="Condições gerais para uso da plataforma Lead Conversa."
      lastUpdated={COMPANY.lastUpdatedLegal}
    >
      <h2>1. Aceitação</h2>
      <p>
        Estes Termos de Uso regulam o acesso e a utilização da plataforma{" "}
        <strong>Lead Conversa</strong>, produto da <strong>{COMPANY.legalEntity}</strong>,
        inscrita no CNPJ nº {COMPANY.cnpj}, com sede em {COMPANY.addressFormatted}. Ao criar
        uma conta, contratar um plano ou utilizar qualquer funcionalidade da plataforma, você
        ("Cliente" ou "Usuário") declara ter lido, compreendido e concordado com estes Termos e
        com a nossa{" "}
        <a href="/privacidade">Política de Privacidade</a>.
      </p>

      <h2>2. Descrição do serviço</h2>
      <p>
        A Lead Conversa é uma plataforma SaaS que oferece recursos de:
      </p>
      <ul>
        <li>Atendimento e conversas multicanal (WhatsApp, e-mail);</li>
        <li>CRM e gestão de contatos, tags e segmentos;</li>
        <li>Disparo de campanhas de e-mail marketing e mensagens via WhatsApp;</li>
        <li>Automação de fluxos, sequências e mensagens;</li>
        <li>Relatórios e analytics.</li>
      </ul>
      <p>
        Os recursos disponíveis podem variar conforme o plano contratado.
      </p>

      <h2>3. Cadastro e conta</h2>
      <p>
        O Cliente é responsável pela veracidade das informações fornecidas no cadastro e pela
        guarda das credenciais de acesso. Qualquer atividade realizada em sua conta é de sua
        exclusiva responsabilidade. Notifique-nos imediatamente em caso de suspeita de uso não
        autorizado.
      </p>

      <h2>4. Obrigações do Cliente</h2>
      <p>Ao utilizar a plataforma, o Cliente compromete-se a:</p>
      <ul>
        <li>
          Respeitar a legislação brasileira aplicável, especialmente a LGPD, o Marco Civil da
          Internet, o Código de Defesa do Consumidor e normas da ANATEL/ANPD.
        </li>
        <li>
          Enviar comunicações apenas a destinatários que tenham concedido{" "}
          <strong>consentimento prévio e verificável</strong> ou que se enquadrem em outra base
          legal adequada sob a LGPD.
        </li>
        <li>
          Não enviar spam, conteúdo enganoso, phishing, material ilegal, discriminatório, de
          ódio, pornográfico ou que viole direitos de terceiros.
        </li>
        <li>
          Incluir mecanismo de descadastramento funcional em todas as comunicações de marketing
          enviadas, bem como dados de identificação do remetente conforme exigido por lei.
        </li>
        <li>
          Não utilizar a plataforma para envio de mensagens em volume acima dos limites do plano
          contratado nem para burlar mecanismos antifraude/antispam.
        </li>
        <li>
          Manter a base de contatos atualizada, honrando solicitações de descadastro,
          correção e exclusão feitas pelos titulares.
        </li>
      </ul>

      <h2>5. Uso proibido</h2>
      <p>É expressamente vedado:</p>
      <ul>
        <li>Praticar engenharia reversa, decompilar ou copiar o software;</li>
        <li>Acessar áreas restritas ou dados de outros clientes;</li>
        <li>
          Utilizar a plataforma para atividades ilícitas, incluindo pirâmides financeiras,
          fraudes ou golpes;
        </li>
        <li>
          Carregar ou transmitir vírus, malware ou qualquer código malicioso.
        </li>
      </ul>
      <p>
        A Lead Conversa poderá suspender ou encerrar contas que violem estes Termos,
        independentemente de aviso prévio em caso de abuso grave.
      </p>

      <h2>6. Planos, pagamento e cancelamento</h2>
      <p>
        Os planos, preços e formas de pagamento estão descritos no site e/ou no contrato
        específico firmado com o Cliente. O não pagamento implica suspensão do acesso. O Cliente
        pode cancelar sua assinatura a qualquer tempo, sem reembolso proporcional de ciclos já
        iniciados, salvo disposição em contrário.
      </p>

      <h2>7. Propriedade intelectual</h2>
      <p>
        Todos os direitos relativos à plataforma — software, código-fonte, marcas, layout,
        textos e identidade visual — são de titularidade exclusiva da {COMPANY.legalEntity} ou
        licenciados a ela. O Cliente retém a propriedade do conteúdo que carrega na plataforma,
        concedendo à Lead Conversa licença limitada para processá-lo exclusivamente para
        prestação do serviço.
      </p>

      <h2>8. Disponibilidade e limitação de responsabilidade</h2>
      <p>
        Envidamos esforços razoáveis para manter a plataforma disponível e segura. Contudo, o
        serviço é fornecido "no estado em que se encontra", podendo haver manutenções,
        indisponibilidades programadas ou falhas decorrentes de terceiros (provedores de nuvem,
        Meta/WhatsApp, provedores de e-mail etc.). Na máxima extensão permitida pela lei, a responsabilidade
        total da Lead Conversa por qualquer reclamação relacionada ao serviço fica limitada ao
        valor pago pelo Cliente nos 12 meses anteriores ao evento.
      </p>

      <h2>9. Privacidade e proteção de dados</h2>
      <p>
        O tratamento de dados pessoais é regido pela nossa{" "}
        <a href="/privacidade">Política de Privacidade</a> e pelo{" "}
        <a href="/lgpd">Aviso LGPD</a>, que integram estes Termos para todos os fins.
      </p>

      <h2>10. Alterações destes Termos</h2>
      <p>
        Podemos atualizar estes Termos a qualquer momento. Alterações materiais serão comunicadas
        com antecedência razoável por e-mail ou aviso na plataforma. A utilização continuada do
        serviço após a entrada em vigor implica aceitação das novas condições.
      </p>

      <h2>11. Lei aplicável e foro</h2>
      <p>
        Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro
        da Comarca de São José do Rio Preto/SP para dirimir quaisquer controvérsias, com renúncia
        expressa a qualquer outro, por mais privilegiado que seja.
      </p>

      <h2>12. Contato</h2>
      <p>
        Dúvidas sobre estes Termos podem ser enviadas para{" "}
        <a href={`mailto:${COMPANY.supportEmail}`}>{COMPANY.supportEmail}</a>.
      </p>
    </LegalPageLayout>
  );
}
